import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Button, Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, Form, FormGroup, Alert } from 'reactstrap';

import Dropzone from 'react-dropzone';
// availity-reactstrap-validation
import { AvField, AvForm } from 'availity-reactstrap-validation';
//Import Breadcrumb
import Breadcrumb from '../../components/Breadcrumb';
//Import Form to edit
import FormEdit from '../../pages/Authentication/FormEdit';
// actions
import { editPhoto, editProfile, editPassword } from '../../store/profile/actions';

import BtnLoader from '../../components/Loaders/btnLoader';
// import PageLoader from '../../components/Loaders/pageLoader';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileData: this.props.profileData,
      isFormVisible: false,
      modalFile: false,
      modalPassword: false,
      selectedFiles: []
    };
    this.toggleFileModal = this.toggleFileModal.bind(this);
    this.togglePwdEdit = this.togglePwdEdit.bind(this);

    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this);
    this.handleValidPwdSubmit = this.handleValidPwdSubmit.bind(this);
    this.handleValidEmployeeSubmit = this.handleValidEmployeeSubmit.bind(this);
  }
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props !== prevProps) {
      this.props.selectedProfile && typeof this.props.selectedProfile.length === 'undefined'
        ? this.setState({ profileData: this.props.selectedProfile })
        : this.setState({ profileData: this.props.profileData });
    }
  }
  /**
   * Toggle photo upload modal
   */
  toggleFileModal = () => this.setState((prevState) => ({ modalFile: !prevState.modalFile }));
  /**
   * Toggle password change modal
   */
  togglePwdEdit = () => this.setState((prevState) => ({ modalPassword: !prevState.modalPassword }));
  /**
   * Handles uploaded file and returns an array of files
   */
  handleAcceptedFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        acceptedFiles: 'image/*',
        formattedSize: this.formatBytes(file.size)
      })
    );
    this.setState({ selectedFiles: files });
  };
  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
  /**
   * Generates base64 string from uploaded picture profile
   */
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  /**
   * Handling employee photo change
   */
  handlePhotoSubmit = async (e, data) => {
    e.preventDefault();
    const { onEditPhoto } = this.props;
    const { profileData, selectedFiles } = this.state;

    const formData = new FormData();
    formData.append('file', selectedFiles[0]);
    formData.append('oldFile', profileData.profilePic);
    try {
      // Send files to the backend
      const response = await fetch('https://koru-ms.com/api/profile/uploadProfilePic', {
        method: 'POST',
        body: formData
      });
      console.log(response);
      if (!response.ok) throw new Error('File upload failed');
      const filePath = await response.json(); // Assume the server responds with the file paths

      // Update profile data with file paths
      const updatedFile = [
        {
          _id: profileData._id,
          workEmail: profileData.workEmail,
          file: filePath // Adjust if multiple files are uploaded
        }
      ];
      onEditPhoto(updatedFile);
      this.toggleFileModal();
      // window.location.reload();
    } catch (error) {
      console.error('Error uploading file:', error);
    }
    // for (var i = 0; i < this.state.selectedFiles.length; i++) {
    //   let file = this.state.selectedFiles[i]
    //   this.getBase64(file).then(file_url => {
    //     const updatedFile = [
    //       { _id: profileData._id, workEmail: profileData.workEmail, file: file_url },
    //     ]
    //     onEditPhoto(updatedFile)
    //     this.toggleFileModal()
    //   })
    // }
  };
  /**
   * Handling employee password change
   */
  handleValidPwdSubmit = (e, values) => {
    const { onEditPassword } = this.props;
    const { profileData } = this.state;
    const newUserPassword = {
      _id: profileData._id,
      workEmail: profileData.workEmail,
      currentPwd: values['currentPwd'],
      newPwd: values['newPwd'],
      confPwd: values['confPwd']
    };
    // edit password
    onEditPassword(newUserPassword);
  };
  /**
   * Handling employee data form submission
   */
  handleValidEmployeeSubmit = (e, values) => {
    const { onEditProfile } = this.props;
    const { profileData } = this.state;
    const updateEmployee = {
      _id: profileData._id,
      fname: values['fname'],
      sname: values['sname'],
      workEmail: values['workEmail'],
      persEmail: values['persEmail'],
      mobPhoneOne: values['mobPhoneOne'],
      mobPhoneTwo: values['mobPhoneTwo'],
      deskPhone: values['deskPhone']
    };
    // update employee information
    onEditProfile(updateEmployee);
    this.setState({ isFormVisible: false });
  };
  render() {
    const { selectedProfile, loading, error, success } = this.props;
    const { profileData, isFormVisible, modalFile, modalPassword, selectedFiles } = this.state;
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {/* {profileData.length !== 0 && <PageLoader progress={!loading && { step: 'Completed', time: 100 }} isLoading={loading} />} */}
        <div className='page-content '>
          <Container fluid className='pg-profile'>
            {/* Render Breadcrumb */}
            <Breadcrumb title='Korupharma' breadcrumbItem='Profile' />
            <Row>
              <Col lg='5'>
                <Card className='card-main profile'>
                  <CardBody className='text-center'>
                    <div className={profileData.accType === 'Admin' ? 'rank rank-adm' : 'rank rank-emp'}>
                      <div className='rank-item'>
                        <span>{profileData.accType === 'Admin' ? 'ADMINISTRATOR' : 'EMPLOYEE'}</span>
                      </div>
                    </div>
                    <div className='d-flex pt-4 pb-4 ps-4 pe-4'>
                      <div className='card-main-photo'>
                        {!profileData.profilePic ? (
                          <div className='avatar-lg rounded-circle'>
                            <span className='font-size-24 avatar-title rounded-circle'>{profileData.fname.charAt(0)}</span>
                          </div>
                        ) : (
                          <div>
                            <img className='avatar-lg rounded-circle' src={profileData.profilePic} alt='' />
                          </div>
                        )}

                          <div className='overlay-photo'>
                            <span className='overlay-photo-icon'>
                              <Button color='link' onClick={this.toggleFileModal}>
                                <i className='bx bx-upload' /> Upload a photo{' '}
                              </Button>
                              {/* Update photo modal window  */}
                              <Modal size='xl' isOpen={modalFile} className={this.props.className} toggle={this.toggleFileModal}>
                                <ModalHeader toggle={this.toggleFileModal} tag='h4'>
                                  Add Picture
                                </ModalHeader>
                                <ModalBody>
                                  <Form onSubmit={this.handlePhotoSubmit}>
                                    <Row>
                                      <Col lg='7'>
                                        <Dropzone accept='.jpeg,.jpg,.png' onDrop={(acceptedFiles) => this.handleAcceptedFiles(acceptedFiles)}>
                                          {({ getRootProps, getInputProps }) => (
                                            <div className='dropzone'>
                                              <div className='dz-message needsclick' {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <div className='mb-3'>
                                                  <i className='display-4 text-muted bx bxs-cloud-upload' />
                                                </div>
                                                <h4>Drop files here or click to upload.</h4>
                                              </div>
                                            </div>
                                          )}
                                        </Dropzone>
                                      </Col>
                                      <Col lg='1' className='m-auto'>
                                        {' '}
                                        <i className='bx bx-up-arrow-alt bx-md transform90' />
                                      </Col>
                                      <Col lg='4'>
                                        <div className='dropzone-previews mt-3' id='file-previews'>
                                          {selectedFiles.map((f, i) => {
                                            return (
                                              <Card className='mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete' key={i + '-file'}>
                                                <div className='p-2'>
                                                  <Row className='align-items-center'>
                                                    <Col className='col-auto m-auto'>
                                                      <div className='new-photo'>
                                                        <img data-dz-thumbnail='' height='80' className='avatar-lg rounded-circle bg-light' alt={f.name} src={f.preview} />
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Card>
                                            );
                                          })}
                                        </div>
                                      </Col>
                                    </Row>
                                    <div className='text-center mt-4'>
                                      <button type='submit' className='btn btn-primary'>
                                        {' '}
                                        Update Photo{' '}
                                      </button>
                                    </div>
                                  </Form>
                                </ModalBody>
                              </Modal>
                            </span>
                          </div>

                      </div>
                    </div>
                    {!selectedProfile && !isFormVisible && (
                      <>
                        <Button color='secondary' outline className='mb-4' onClick={() => this.setState({ isFormVisible: true })}>
                          <i className='mdi mdi-pencil font-size-16 '></i> Edit Profile
                        </Button>
                        &nbsp; &nbsp; &nbsp;
                        <Button color='primary' outline className='mb-4' onClick={() => this.togglePwdEdit()}>
                          <i className='mdi mdi-lock font-size-16 '></i> Update Password
                        </Button>
                        {/* Update password modal window */}
                        <Modal size='sm' isOpen={modalPassword} className={this.props.className} toggle={this.togglePwdEdit}>
                          <ModalHeader toggle={this.togglePwdEdit} tag='h4'>
                            Update Password
                          </ModalHeader>
                          <ModalBody>
                            {error && error ? <Alert color='danger'>{error}</Alert> : null}
                            {success && success ? [(this.state.modalPassword = false)] : null}
                            <AvForm onValidSubmit={this.handleValidPwdSubmit}>
                              <Row>
                                <Col md={12}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='currentPwd'
                                      type='password'
                                      label='Current Password'
                                      value=''
                                      errorMessage='Fill in current password'
                                      validate={{
                                        required: { value: true }
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={12}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='newPwd'
                                      type='password'
                                      label='New Password'
                                      value=''
                                      errorMessage='Fill in new password'
                                      validate={{
                                        required: { value: true }
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={12}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='confPwd'
                                      type='password'
                                      label='Confirm Password'
                                      value=''
                                      errorMessage='Fill in confirm password'
                                      validate={{
                                        required: { value: true }
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className='text-end'>
                                    {loading && <BtnLoader />}
                                    <button className='btn btn-success save-user' disabled={loading && true}>
                                      Edit Password
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </AvForm>
                          </ModalBody>
                        </Modal>
                      </>
                    )}
                    {isFormVisible && (
                      <div className='btn-group btn-group-example mb-3' role='group'>
                        <Button color='success' form='my-form' type='submit' className='w-md'>
                          <i className='bx bx-check-double font-size-16 align-middle ms-2 me-1'></i>
                          Save
                        </Button>
                        <Button color='danger' className='w-md' onClick={() => this.setState({ isFormVisible: false })}>
                          <i className='bx bx-block font-size-16 align-middle ms-2 me-1'></i>
                          Cancel
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </Card>
                <Card className='card-days profile'></Card>
                <Card className='card-days profile'></Card>
              </Col>
              <Col lg='7'>
                <Card className='profile'>
                  <CardBody>
                    <h4 className='card-title mb-4'>Contact Information</h4>
                    <hr />
                    <Row className='info'>
                      {isFormVisible && <FormEdit profileData={profileData} handleValidEmployeeSubmit={this.handleValidEmployeeSubmit} />}
                      {!isFormVisible && (
                        <>
                          <Col md={12}>
                            <p className='text-muted mb-0'>First Name</p>
                            <span className='editProfile'>{profileData.fname} </span>
                          </Col>
                          <Col md={12}>
                            <p className='text-muted mb-0'>Last Name</p>
                            <span className='editProfile'>{profileData.sname} </span>
                          </Col>
                          <Col md={12}>
                            <p className='text-muted mb-0'>Contact Email</p>
                            <span className='editProfile'>{profileData.workEmail} </span>
                          </Col>
                          <Row className='mb-3'>
                            <Col md={4}>
                              <p className='text-muted mb-0'>Phone №</p>
                              <span className='editProfile'>{profileData.mobPhoneOne} </span>
                            </Col>
                            <Col md={2}>
                              <p className='text-muted mb-0'>Desk №</p>
                              <span className='editProfile'>{profileData.deskPhone} </span>
                            </Col>
                            <Col md={4}>
                              {profileData.mobPhoneTwo && <p className='text-muted mb-0'>Additional №</p>}
                              <span className='editProfile'>{profileData.mobPhoneTwo} </span>
                            </Col>
                          </Row>
                          <Col md={12}>
                            <p className='text-muted mb-0'>Personal email</p>
                            <span className='editProfile'>{profileData.persEmail} </span>
                          </Col>
                        </>
                      )}
                      <Col md={12}>
                        <p className='text-muted mb-0'>Position</p>
                        <span className='editProfile'>{profileData.position} </span>
                      </Col>
                      <Col md={12}>
                        <p className='text-muted mb-0'>Department</p>
                        <span className='editProfile'>{profileData.department.depName} </span>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

UserProfile.propTypes = {
  onEditProfile: PropTypes.func,
  onEditPhoto: PropTypes.func,
  onEditPassword: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any
};

const mapStateToProps = (state) => {
  const { error, success, loading } = state.Profile;
  return { error, success, loading };
};

const mapDispatchToProps = (dispatch) => ({
  onEditProfile: (employee) => dispatch(editProfile(employee)),
  onEditPhoto: (employee) => dispatch(editPhoto(employee)),
  onEditPassword: (employee) => dispatch(editPassword(employee))
});

// export default withRouter(
//   connect(mapStateToProps, { editProfile, resetProfileFlag })(UserProfile)
// )
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserProfile));
